import { render, staticRenderFns } from "./TopMiddleCmp.vue?vue&type=template&id=6679e81a"
import script from "./TopMiddleCmp.vue?vue&type=script&lang=js"
export * from "./TopMiddleCmp.vue?vue&type=script&lang=js"
import style0 from "./TopMiddleCmp.vue?vue&type=style&index=0&id=6679e81a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports